module.exports = __webpack_public_path__ + "static/media/8_nature.05c5c5db.jpg";